import { updateBusinessTheme, updateStoreTheme } from 'api/admin/businesses/businesses';

export const saveThemeChanges = async ({ initialTheme, newTheme, url, name }) => {
  const isStoreTheme = Boolean(newTheme?.storeId);
  const newThemeObj = Object.assign(
    url !== initialTheme.customUrl && url !== initialTheme.encodedLink ? { customUrl: url } : {},
    name && isStoreTheme ? { name } : {},
    newTheme,
  );

  if (isStoreTheme) {
    await updateStoreTheme(initialTheme?.id, newThemeObj);
  } else {
    const { primaryColor, logoUrl, borderRadius } = initialTheme;
    newThemeObj.initialTheme = {
      primaryColor,
      logoUrl,
      borderRadius,
    };
    await updateBusinessTheme(initialTheme.id, newThemeObj);
  }
};
